import styled from 'styled-components';
import { media, colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import PriceChart from '@bitcoin-portal/bitcoincom-pkg-components/dist/PriceChart';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  padding-top: 30px;
`;

export const StyledContentBlock = styled(ContentBlock)`
  align-items: flex-start;
  justify-content: space-evenly;
  padding: 0;

  & > :first-child {
    margin-top: 48px;
    ${media.md`
      margin-top: 0;
    `}
  }

  & > :last-child {
    text-align: center;
  }
`;

export const Heading = styled.div`
  margin: auto;
  text-align: center;

  p {
    margin: auto;
    color: ${colors.solid.textTwo};
    width: 80%;
  }

  ${media.lg`
    padding-bottom: 65px;

    p {
      max-width: 600px;
      margin: 0 auto;
      padding-bottom: 0;
    }
  `}
`;

export const ImageWrapper = styled.div`
  height: 318px;

  ${media.md`
    height: 400px;
  `};

  ${media.xl`
    height: 550px;
  `}
`;

export const MediaWrapper = styled(ContentBlock)`
  display: none;

  ${media.md`
    display: flex;
    align-items: center;
    padding-top: 100px !important;
  `}
`;

export const ChartWrapper = styled.div`
  h3 {
    text-align: center;
  }
  h5 {
    line-height: 1.3;
    font-size: 22px;
    text-align: center;
  }
  .supply {
    font-weight: bold;
    color: ${colors.solid.primaryBlue};
  }
  ${media.md`
    h3 {
      text-align: left;
    }
    h5 {
      text-align: left;
      font-size: 30px;
    }
  `}
`;

export const StyledChart = styled(PriceChart)`
  margin: 0 0 0 -40px;
  > div {
    padding-bottom: 40%;
  }
`;

export const Notice = styled.div`
  background: #c9d6e4;
  padding: 16px;
  text-align: center;
  margin-bottom: 24px;
  > div {
    > svg {
      vertical-align: top;
      margin-right: 8px;
    }
    max-width: 800px;
    margin: 0px auto;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
    color: #4a5264;
  }
  ${media.lg`
    margin-bottom: 64px;
    > div {
      font-size: 16px;
    }
  `}
`;

export const HeaderText = styled.div`
  & > * {
    text-align: center;
    ${media.md`
      text-align: left;
    `}
  }
  & > h1 {
    ${media.md`
      padding-bottom: 24px;
    `}
    ${media.lg`
      padding-bottom: 24px;
    `}
    ${media.xl`
      padding-bottom: 32px;
    `}
  }
  & > p {
    color: ${colors.solid.textTwo};
    padding-bottom: 0;
    ${media.md`
      max-width: 420px;
    `}
  }
`;

export const WidgetWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  width: 100% !important;
  margin: auto;
`;
